import { FC } from 'react';
import { Box, Typography } from '@mui/material';

export interface ChipFieldProps {
  /** Display label (e.g. "Order Number", "Specimen Type") */
  label: string;
  /** Value shown in the chip */
  value: string;
  /** Optional test id applied to the value element */
  'data-testid'?: string;
}

/**
 * Displays a label and value as a chip. Use for read-only key-value display
 * (e.g. order number, specimen type) in forms or headers.
 */
export const ChipField: FC<ChipFieldProps> = ({
  label,
  value,
  'data-testid': dataTestId,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography
        variant='body2'
        component='span'
        sx={{
          color: 'text.primary',
          fontWeight: 500,
        }}
      >
        {label}:
      </Typography>
      <Typography
        variant='body2'
        color='primary'
        component='span'
        sx={{
          fontWeight: 600,
        }}
        data-testid={dataTestId}
      >
        {value}
      </Typography>
    </Box>
  );
};
